import { Injectable } from '@angular/core';
import { environment } from '../../../env/environment';
import platformClient from 'purecloud-platform-client-v2';
import { Observable, from, of, BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class GenesysService {

  private client = platformClient.ApiClient.instance;
  private usersApi = new platformClient.UsersApi();
  //private tokensApi = new platformClient.TokensApi();
  private conversationInstance = new platformClient.ConversationsApi();

  // Authorization values
  region: string = 'mypurecloud.de';
  private accessToken = '';
  isAuthorized = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  private loginImplicitGrant(): Observable<platformClient.AuthData> {
    return from(this.client.loginImplicitGrant(environment.GENESYS_CLOUD_CLIENT_ID, environment.REDIRECT_URI))
      .pipe(
        map(data => {
          this.accessToken = data.accessToken;
          this.isAuthorized.next(true);
          console.log('Connected to Genesys successully.');
          return data;
        }),
        catchError(error => {
          console.error('Failed to connect to Genesys : ', error);
          this.isAuthorized.next(false);
          return throwError(() => new Error('Authorization failed. Please try again.'));
        })
      );
  }

  initialize(): Observable<any> {
    // Using Persistence from Genesys, storing token in localstorage by default.
    // TOKEN EXPIRES AFTER 48H
    this.client.setPersistSettings(true);
    this.client.setEnvironment(this.region);

    return this.loginImplicitGrant();
  }

  getUserMe(): Observable<platformClient.Models.UserMe> {
    return from(this.usersApi.getUsersMe({
      expand: ['routingStatus', 'presence', 'skills'],
    }));
  }

  // call customer number by Genesys API.
  callNumber(body: any): Observable<any> {
    return from(this.conversationInstance.postConversationsCalls(body)
      .then((data) => {
        console.log("Call success.");
        return (data);
      })
      .catch((err) => {
        console.log("There was a failure calling postConversationsCalls");
        return (err);
      }))
  }

  // EMAIL : CREATE EMAIL CONVERSATION
  createEmailConversation(body: any): Observable<any> {
    return from(this.conversationInstance.postConversationsEmails(body)
      .then((data) => {
        console.log("Email conversation created.");
        return (data);
      })
      .catch((err) => {
        console.log("There was a failure calling postConversationsEmails");
        return (err);
      }))
  }
  // EMAIL : SEND EMAIL (for auto send)
  sendEmail(conversationId: string, body: any): Observable<any> {
    return from(this.conversationInstance.postConversationsEmailMessages(conversationId, body)
      .then((data) => {
        console.log("Email sent.");
        return (data);
      })
      .catch((err) => {
        console.log("There was a failure sending email, postConversationsEmailMessages");
        return (err);
      }))
  }
  // EMAIL : WRAP UP
  applyWrapupEmail(conversationId: string, participantId: string, body: any): Observable<any> {
    return from(this.conversationInstance.patchConversationsEmailParticipant(conversationId, participantId, body)
      .then((data) => {
        console.log("Wrap-up set.");
        return (data);
      })
      .catch((err) => {
        console.log("There was a failure applying wrap-up, patchConversationsEmailParticipant");
        return (err);
      }))
  }
  // EMAIL : GET CONVERSATION PARTICIPANT ID
  getEmailConversation(conversationId: string): Observable<any> {
    return from(this.conversationInstance.getConversationsEmail(conversationId)
      .then((data) => {
        console.log("Conversation participant ID retrieved.");
        return (data);
      })
      .catch((err) => {
        console.log("There was a failure retrieving participantData, getConversationsEmail");
        return (err);
      }))
  }
  // CALL : WRAP UP
  applyWrapupCall(conversationId: string, participantId: string, body: any): Observable<any> {
    return from(this.conversationInstance.patchConversationsCallParticipant(conversationId, participantId, body)
      .then((data) => {
        console.log("Wrap-up set.");
        return (data);
      })
      .catch((err) => {
        console.log("There was a failure applying wrap-up, patchConversationsCallParticipant");
        return (err);
      }))
  }
  // CALL : GET CONVERSATION PARTICIPANT ID
  getCallConversation(conversationId: string): Observable<any> {
    return from(this.conversationInstance.getConversationsCall(conversationId)
      .then((data) => {
        console.log("Conversation participant ID retrieved.");
        return (data);
      })
      .catch((err) => {
        console.log("There was a failure retrieving participantData, getConversationsCall");
        return (err);
      }))
  }

  // CALL : HANGUP // WILL SET CONVERSATION STATE TO DISCONNECTED
  hangupCall(conversationId: string, body: any): Observable<any> {
    return from(this.conversationInstance.patchConversationsCall(conversationId, body)
      .then((data) => {
        console.log("Call disconnected.");
        return (data);
      })
      .catch((err) => {
        console.log("There was a failure disconnecting call, patchConversationsCall");
        return (err);
      }))
  }
}
